const menu = () => {
  return [
    {
      title: 'Menu',
      route: 'menu',
      icon: 'MenuIcon',
      permission: ['A', 'C', 'S', 'I']
    },
    {
      title: 'Tablero GWH00-79',
      route: 'dashboardGWH0079',
      icon: 'LayoutIcon',
      permission: ['A', 'C', 'S', 'I']
    },
    {
      title: 'Medidores GWH00-79',
      route: 'metersGWH0079',
      icon: 'CompassIcon',
      permission: ['A', 'C', 'S', 'I']
    },
    {
      title: 'Mapa GWH00-79',
      route: 'mapGWH0079',
      icon: 'MapIcon',
      permission: ['A', 'C', 'S']
    },
    /*
    {
      title: 'Tablero',
      route: 'dashboard',
      icon: 'LayoutIcon',
      permission: ['A', 'C', 'S', 'I']
    },
    {
      title: 'Gabinetes',
      route: 'gabinets',
      icon: 'ZapIcon',
      permission: ['A', 'C', 'S', 'I']
    },
    {
      title: 'Medidores',
      route: 'meters',
      icon: 'CompassIcon',
      permission: ['A', 'C', 'S', 'I']
    },
    {
      title: 'Mapa',
      route: 'map',
      icon: 'MapIcon',
      permission: ['A', 'C', 'S']
    },
    */
    {
      title: 'Agencias',
      route: 'agencies',
      icon: 'BriefcaseIcon',
      permission: ['A', 'C']
    },
    {
      title: 'Proyectos',
      route: 'projects',
      icon: 'FolderIcon',
      permission: ['A', 'C']
    },
    {
      title: 'Cuadrillas',
      route: 'teams',
      icon: 'ToolIcon',
      permission: ['A', 'C']
    },
    {
      title: 'Gruas',
      route: 'cranes',
      icon: 'TruckIcon',
      permission: ['A', 'C']
    },
    {
      title: 'Zonas',
      route: 'zones',
      icon: 'MapIcon',
      permission: ['A', 'C']
    },
    {
      title: 'Usuarios',
      route: 'users',
      icon: 'UserIcon',
      permission: ['A', 'C']
    }
  ]
}

export default menu()
